import React, { createContext, useContext, useEffect, useState } from "react";
import { MapRef } from "react-map-gl";
import AuthManager from "src/auth/AuthManager";
interface AppContextProps {
  LayoutButton: React.JSX.Element;
  setLayoutButton: (title: React.JSX.Element) => void;
  mapRef: React.RefObject<MapRef> | null;
  setMapRef: (mapRef: React.RefObject<MapRef> | null) => void;
}

const AppContext = createContext<AppContextProps | undefined>(undefined);

export const AppContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [LayoutButton, setLayoutButton] = useState(<></>);
  const [mapRef, setMapRef] = useState<React.RefObject<MapRef> | null>(null);
  useEffect(() => {}, [location.pathname]);

  return (
    <AppContext.Provider
      value={{ LayoutButton, setLayoutButton, mapRef, setMapRef }}
    >
      {children}
    </AppContext.Provider>
  );
};

export function useAppContext() {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useLayout must be used within a LayoutProvider");
  }
  return context;
}
